/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import * as selectorsProdutos from '../../../store/produto/reducer';
import { saveProduto, updateProduto, findProdutoById } from '../../../store/produto/actions';
import moment from 'moment';
import { codeFormatter } from 'utils';
import {
  InputV2,
  DialogDefaultV2,
  ArquivoContainerV2,
  TrueFalseSelectV2,
  TabFormV2,
} from '../../../components/v2';
import ProdutoTamanhoTable from './ProdutoTamanhoTable';
import ProdutoExtratoTab from './ProdutoExtratoTab';

const schema = {
  nome: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  possuiTamanho: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  ativo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const Formulario = ({
  saveProduto,
  updateProduto,
  selectedProduto,
  open,
  id,
  onClose,
  onPersisted,
  findProdutoById,
  initialTab,
  initialLocal,
}) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    if (open) {
      setValues({
        data: moment().valueOf(),
        ativo: true,
      });
    } else {
      setValues({});
      setCurrentTab(0);
    }
  }, [open]);

  useEffect(() => {
    if (open) {
      setCurrentTab(initialTab === 'extrato' && id ? 1 : 0);
    }
  }, [open, initialTab]);

  useEffect(() => {
    if (id) findProdutoById(id);
  }, [id, findProdutoById]);

  useEffect(() => {
    if (id && selectedProduto && String(id) === String(selectedProduto.id)) {
      const next = { ...selectedProduto };
      if (!next.data) next.data = moment().valueOf();
      else next.data = Number(next.data);
      setValues(next);
    } else if (!id) {
      setValues({
        data: moment().valueOf(),
        ativo: true,
      });
    }
  }, [id, selectedProduto]);

  const onSave = () => {
    let erros = validate(values, schema);
    if ((values.possuiTamanho === "true" || values.possuiTamanho === true) && (!values.produtoTamanhos || values.produtoTamanhos.length === 0)) {
      erros = erros ? { ...erros, possuiTamanhoList: true } : { possuiTamanhoList: true };
    }
    setErrors(erros);
    if (!erros) {
      if (values.id) {
        updateProduto(values, saveCallback);
      } else {
        const payload = { ...values };
        delete payload.codigo;
        saveProduto(payload, saveCallback);
      }
    }
  };

  const saveCallback = (success, saved) => {
    if (success) {
      onPersisted(saved || values);
    }
  };

  const onCloseLocal = isSave => {
    setErrors({});
    setValues({});
    setCurrentTab(0);
    onClose(isSave);
  };

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const onSaveTamanhos = produtoTamanhos => {
    setValues({
      ...values,
      produtoTamanhos
    });
  };

  const isNew = !values.id;
  const codigoLabel = values.codigo ? codeFormatter(values.codigo) : '';
  const dialogTitle = values.nome
    ? `Produto — ${values.nome}${codigoLabel ? ` (${codigoLabel})` : ''}`
    : 'Produto';

  const cadastroForm = (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 1 }}>
        <InputV2
          disabled
          label="Código"
          name="codigo"
          value={isNew ? '' : codigoLabel}
          placeholder="Geração após o cadastro"
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <InputV2
          label="Nome"
          name="nome"
          onChange={handleChange}
          value={values.nome}
          isRequired
          error={!!(errors && errors.nome)}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <TrueFalseSelectV2
          error={!!(errors && errors.possuiTamanho)}
          isRequired
          label="Possui tamanho"
          name="possuiTamanho"
          onChange={handleChange}
          value={values.possuiTamanho}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 2 }}>
        <TrueFalseSelectV2
          error={!!(errors && errors.ativo)}
          isRequired
          label="Ativo"
          name="ativo"
          onChange={handleChange}
          value={values.ativo}
        />
      </Grid>
      {id && (
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            disabled
            label="Quantidade total"
            value={values.quantidade}
          />
        </Grid>
      )}
      <Grid size={{ xs: 12 }}>
        <InputV2
          label="Descrição"
          name="descricao"
          onChange={handleChange}
          value={values.descricao}
          rows={3}
          multiline
        />
      </Grid>
      {(values.possuiTamanho === "true" || values.possuiTamanho === true) && (
        <ProdutoTamanhoTable
          tamanhos={values.produtoTamanhos}
          onSave={onSaveTamanhos}
          showError={!!(errors && errors.possuiTamanhoList)}
        />
      )}
      <ArquivoContainerV2
        arquivos={values.arquivos}
        onSave={arquivos => setValues({ ...values, arquivos })}
      />
    </Grid>
  );

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title={dialogTitle}
      confirmMessage="Salvar"
      maxWidth="lg"
      fullWidth
    >
      <TabFormV2
        currentTab={currentTab}
        onChangeTab={setCurrentTab}
        keepMounted
        tabPanels={[
          {
            label: 'Informações básicas',
            element: cadastroForm,
          },
          {
            label: 'Extrato',
            disabled: !id,
            element: (
              <ProdutoExtratoTab
                produtoId={id}
                initialLocal={initialLocal}
              />
            ),
          },
        ]}
      />
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  saveProduto: PropTypes.func.isRequired,
  updateProduto: PropTypes.func.isRequired,
  selectedProduto: PropTypes.object,
  open: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func.isRequired,
  onPersisted: PropTypes.func,
  findProdutoById: PropTypes.func.isRequired,
  initialTab: PropTypes.string,
  initialLocal: PropTypes.string,
};

Formulario.defaultProps = {
  selectedProduto: null,
  open: false,
  id: null,
  onPersisted: () => {},
  initialTab: null,
  initialLocal: '',
};

const mapStateToProps = state => ({
  selectedProduto: selectorsProdutos.getSelectedProduto(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  saveProduto,
  updateProduto,
  findProdutoById,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Formulario);
